import { __assign, __rest } from "tslib";
import { cx } from 'emotion';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import _ from 'lodash';
import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';
export var FormField = function (props) {
    var formik = useFormikContext();
    var errors = formik.errors, touched = formik.touched;
    var name = props.name, className = props.className, wrapperProps = props.wrapperProps, formGroupProps = props.formGroupProps, labelProps = props.labelProps, children = props.children, rest = __rest(props, ["name", "className", "wrapperProps", "formGroupProps", "labelProps", "children"]);
    var isInvalid = !!errors[name] && !!touched[name];
    var renderField = function () {
        if (children) {
            if (_.isFunction(children)) {
                return (React.createElement(Field, __assign({ name: name, className: cx(['form-control', { 'is-invalid': isInvalid }]) }, rest), function (childProps) { return children(childProps); }));
            }
            else {
                return (React.createElement(Field, __assign({ name: name, className: cx(['form-control', { 'is-invalid': isInvalid }]) }, rest, { children: children })));
            }
        }
        else
            return React.createElement(Field, __assign({ name: name, className: cx(['form-control', { 'is-invalid': isInvalid }]) }, rest));
    };
    return (React.createElement(Col, __assign({}, wrapperProps),
        React.createElement(FormGroup, __assign({}, formGroupProps),
            props.label && React.createElement(Label, __assign({}, labelProps), props.label),
            renderField(),
            isInvalid && (React.createElement(ErrorMessage, { name: name, render: function (errorMessage) { return React.createElement("small", { className: "text-danger" }, errorMessage); } })))));
};
//# sourceMappingURL=FormField.js.map